import { InvoiceStatusEnum, InvoiceTypeEnum, InvoiceViewModel } from '@fora-monorepo/employer-my-pages-common/types';

const createMockData = () => {
  return {
    invoiceNumber: (Math.floor(Math.random() * 90000) + 10000).toString(),
    ocr: (Math.floor(Math.random() * 900000) + 100000).toString(),
    invoiceType: InvoiceTypeEnum.Invoice,
    invoiceDate: new Date(
      `2022-${Math.floor(Math.random() * 10 + 1)}-${Math.floor(Math.random() * 30 + 1)}`
    ).toDateString(),
    invoiceDueDate: new Date(
      `2022-${Math.floor(Math.random() * 10 + 1)}-${Math.floor(Math.random() * 30 + 1)}`
    ).toDateString(),
    amount: Math.floor(Math.random() * 100000),
    amountLeftToPay: Math.floor(Math.random() * 1000),
    showCsvDownloadButton: true,
  };
};

const mockInvoiceListShort: InvoiceViewModel[] = [
  {
    invoiceNumber: '3984753',
    invoiceType: InvoiceTypeEnum.Credit,
    invoiceDate: '2021-09-01',
    invoiceDueDate: '2021-10-01',
    amount: 1500,
    status: InvoiceStatusEnum.Reminded,
    amountLeftToPay: 1000,
    ocr: '987654',
    showCsvDownloadButton: true,
  },
  {
    invoiceNumber: '40958640',
    invoiceType: InvoiceTypeEnum.Invoice,
    invoiceDate: '2021-08-01',
    invoiceDueDate: '2021-09-01',
    amount: 10581,
    status: InvoiceStatusEnum.Disputed,
    amountLeftToPay: 5000,
    ocr: '154858',
    showCsvDownloadButton: true,
  },
  {
    invoiceNumber: '3298472',
    invoiceType: InvoiceTypeEnum.Invoice,
    invoiceDate: '2023-01-21',
    invoiceDueDate: '2023-02-09',
    amount: 1295,
    status: InvoiceStatusEnum.DebtCollection,
    amountLeftToPay: 258,
    ocr: '125218',
    showCsvDownloadButton: true,
  },
  {
    invoiceNumber: '38947557',
    invoiceType: InvoiceTypeEnum.LatePaymentInterest,
    invoiceDate: '2020-12-01',
    invoiceDueDate: '2020-12-29',
    amount: 12502,
    status: InvoiceStatusEnum.Paid,
    amountLeftToPay: 5128,
    ocr: '564278',
    showCsvDownloadButton: false,
  },
];

const invoicesListMockLong: InvoiceViewModel[] = [
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Reminded,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.DebtCollection,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Paid,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.NoStatus,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.NoStatus,
    invoiceType: InvoiceTypeEnum.Credit,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.NoStatus,
    invoiceType: InvoiceTypeEnum.LatePaymentInterest,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.InstallmentPlan,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Paid,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Disputed,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Paid,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.PaymentDeferral,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Paid,
  },
  {
    ...createMockData(),
    status: InvoiceStatusEnum.Paid,
    ocr: '13',
  },
];

export const mockInvoiceList = {
  short: mockInvoiceListShort,
  long: invoicesListMockLong,
};
